import { useSessionMutation as useMutation } from "@/lib/query/core/use-session-mutation";
import { useQueryClient } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";

import { changePrivateSession } from "./privateSessionChange";

type SellerSwitchStoreInput = {
  storeSlug: string;
};

export function useSwitchStoreMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    meta: { skipGlobalErrorToast: true },
    mutationFn: (input: SellerSwitchStoreInput) =>
      changePrivateSession(queryClient, () => apiJsonClient<unknown>(endpoints.seller.auth.switchStore, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input),
      }), input.storeSlug),
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
